import React from 'react';
import Payee from './Payee';

const PayeeComponent = () => <Payee />;

export default PayeeComponent;
